"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.scss"));
var Toggle = function Toggle(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_style.default['content-toggle'], " ").concat(props.className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toggle-label"
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "switch ".concat(props.disabled ? 'disabled' : '')
  }, /*#__PURE__*/_react.default.createElement("input", {
    name: "toggle",
    type: "checkbox",
    "data-value": props.checked,
    checked: props.checked
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "slidercontainer",
    onClick: function onClick() {
      return props.onClick(!props.checked);
    },
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ballslider"
  }), props.checked ? /*#__PURE__*/_react.default.createElement("div", {
    className: "active-text"
  }, props.activeText) : /*#__PURE__*/_react.default.createElement("div", {
    className: "inactive-text"
  }, props.inactiveText))));
};
Toggle.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  activeText: _propTypes.default.string,
  inactiveText: _propTypes.default.string
};
Toggle.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  label: '',
  activeText: 'ON',
  inactiveText: 'OFF'
};
var _default = Toggle;
exports.default = _default;